import api from './APIService';

class EventService {
    getEventList() {
		return api.fetch({ method: 'get', path: '/participant/events/getList' });
	}
}

export default new EventService();
